export class TemplateConfiguration {
  subject: string | null;
  headerContent : string;
  headerBackgroundColor : string;
  body: string;
  headerImg: string | null;
  whatsappButtons: WhatsappButton[];
  payButtonTextColor: string;
  payButtonBackgroundColor: string;
  contactResponseActionButtonTextColor: string;
  contactResponseButtonBackgroundColor: string;
  paymentOrderTableTagConfiguration: PaymentOrderTableTagConfiguration[] | null;
  physicalLetter?: PhysicalLetterConfiguration | null;
}

export const PHYSICAL_LETTER_MAX_PAGES = 5;

export enum PhysicalLetterFooterDisplay {
  ALL_PAGES = 'A',
  LAST_PAGE = 'L',
}

export class PhysicalLetterConfiguration {
  footer: string | null;
  footerDisplay: string;
  senderName: string | null;
  showCompanyLogo: boolean;
  showSendDate: boolean;
  showSignature: boolean;
  signatureImg: string | null;
  signatoryName: string | null;
  signatoryPosition: string | null;
}

export class WhatsappButton {
  type: string;
  buttonText: string;
  url: string;
}

export class PaymentOrderTableTagConfiguration {
  headerCode: string | null;
  headerText: string | null;
}